module.exports = __webpack_public_path__ + "img/i-wx-code.0b57e4de.jpg";